import { Box } from '@mui/material';
import { formatDate, TABLE_TEXT_DATE_TIME_FORMAT } from './helpers/dates';

export const naira = String.fromCharCode(8358);

export const REALM_DISPLAY_NAME = 'Qrios API Developer Portal';

export const supportEmail = 'support@qrios.com';

interface EmptyMsgProps {
  view: string;
  hasActiveFilters: boolean;
  operationType: 'operations' | 'sessions';
  from: string;
  to: string;
}

export const billingTableEmptyMsg = ({ view, hasActiveFilters, operationType, from, to }: EmptyMsgProps) =>
  hasActiveFilters ? (
    <Box>
      {`You don't have any `}
      <b>{`${view} billing ${operationType}`}</b>
      {` for your filter(s) to display`}
    </Box>
  ) : (
    <Box>
      <Box>
        {`You don't have any `}
        <b>{`${view} billing ${operationType}`}</b>
        {' from '}
        <b>{formatDate(from, TABLE_TEXT_DATE_TIME_FORMAT)}</b>
        {' to '}
        <b>{formatDate(to, TABLE_TEXT_DATE_TIME_FORMAT)}</b>
        {' to display'}
      </Box>
      <Box mt={1} textAlign="center">
        {`Use `}
        <b>Filters</b>
        {` button below to change ${operationType} billing results range`}
      </Box>
    </Box>
  );
